var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"row",staticStyle:{"padding-top":"0px","padding-left":"0px"}},[_c('q-page-container',{staticClass:"col",staticStyle:{"padding-top":"0px","padding-left":"0px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }